import { c as _c } from "react/compiler-runtime";
import type { Rule, RuleAction } from '@onefootprint/request-types/dashboard';
import { Divider } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RuleRow from '@/entities/components/details/components/content/components/rule-row';
import RulesDropdown from './components/triggered-dropdown';
export type ContentProps = {
  ruleResults: Record<'triggered' | 'notTriggered', Partial<Record<RuleAction, Rule[]>>>;
  actionTriggered: RuleAction;
};
const Content = t0 => {
  const $ = _c(43);
  const {
    ruleResults,
    actionTriggered
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.ruleSetResults"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [showTriggeredRules, setShowTriggeredRules] = useState(true);
  const shownRuleResults = ruleResults[showTriggeredRules ? "triggered" : "notTriggered"];
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isTriggered => {
      setShowTriggeredRules(isTriggered);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClick = t2;
  const getRuleActionColor = _temp;
  let t3;
  if ($[2] !== t) {
    t3 = action_0 => {
      if (action_0 === "pass") {
        return t(_temp2);
      }
      if (action_0 === "pass_with_manual_review") {
        return t(_temp3);
      }
      if (action_0 === "manual_review") {
        return t(_temp4);
      }
      if (action_0 === "fail") {
        return t(_temp5);
      }
      if (action_0.includes("step_up")) {
        return t(_temp6);
      }
    };
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getRuleActionText = t3;
  let t4;
  if ($[4] !== t) {
    t4 = action_1 => {
      if (action_1 === "step_up.identity") {
        return t(_temp7);
      }
      if (action_1 === "step_up.proof_of_address") {
        return t(_temp8);
      }
      if (action_1 === "step_up.identity_proof_of_ssn") {
        return t(_temp9);
      }
      if (action_1 === "step_up.identity_proof_of_ssn_proof_of_address") {
        return t(_temp10);
      }
    };
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getStepUpActionText = t4;
  let t5;
  if ($[6] !== getRuleActionText || $[7] !== getStepUpActionText) {
    t5 = action_2 => {
      const actionText = <span className={`text-label-2 text-${getRuleActionColor(action_2)}`}>{getRuleActionText(action_2)}</span>;
      if (action_2.includes("step_up")) {
        return <div className="flex gap-1 items-center">{actionText}<span className="text-label-2 text-secondary">{getStepUpActionText(action_2 as RuleAction)}</span></div>;
      }
      return actionText;
    };
    $[6] = getRuleActionText;
    $[7] = getStepUpActionText;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const renderRuleAction = t5;
  let t6;
  if ($[9] !== getRuleActionText || $[10] !== renderRuleAction || $[11] !== showTriggeredRules || $[12] !== shownRuleResults || $[13] !== t) {
    t6 = () => {
      if (Object.keys(shownRuleResults).length === 0) {
        return <span className="text-body-2">{showTriggeredRules ? t(_temp11) : t(_temp12)}</span>;
      }
      return <div className="flex flex-col gap-6">{Object.entries(shownRuleResults).map(t7 => {
          const [action_3, rules] = t7;
          return <fieldset key={action_3} className="flex flex-col gap-3" aria-label={getRuleActionText(action_3 as RuleAction)}>{renderRuleAction(action_3 as RuleAction)}<ul className="flex flex-col gap-2">{rules.map(_temp13)}</ul></fieldset>;
        })}</div>;
    };
    $[9] = getRuleActionText;
    $[10] = renderRuleAction;
    $[11] = showTriggeredRules;
    $[12] = shownRuleResults;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const renderRuleResults = t6;
  let t7;
  if ($[15] !== t) {
    t7 = t(_temp14);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <p className="text-body-2 text-tertiary">{t7}</p>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== actionTriggered || $[20] !== renderRuleAction) {
    t9 = renderRuleAction(actionTriggered);
    $[19] = actionTriggered;
    $[20] = renderRuleAction;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div className="flex items-center justify-between w-full py-2 px-3 border border-solid border-tertiary rounded mb-8">{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t(_temp15);
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11) {
    t12 = <span className="text-label-2">{t11}</span>;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== showTriggeredRules) {
    t13 = <RulesDropdown isShowingTriggered={showTriggeredRules} onClick={handleClick} />;
    $[29] = showTriggeredRules;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <div className="flex items-center justify-between">{t12}{t13}</div>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Divider variant="secondary" className="mb-2" />;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== renderRuleResults) {
    t16 = renderRuleResults();
    $[35] = renderRuleResults;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t16) {
    t17 = <div className="flex flex-col gap-2">{t14}{t15}{t16}</div>;
    $[37] = t14;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t10 || $[41] !== t17) {
    t18 = <div className="flex flex-col">{t10}{t17}</div>;
    $[40] = t10;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};
export default Content;
function _temp(action) {
  if (action === "pass") {
    return "success";
  }
  if (action === "pass_with_manual_review") {
    return "success";
  }
  if (action === "manual_review") {
    return "warning";
  }
  if (action === "fail") {
    return "error";
  }
  return "info";
}
function _temp2($) {
  return $.action.pass;
}
function _temp3($_0) {
  return $_0.action.passWithManualReview;
}
function _temp4($_1) {
  return $_1.action.manualReview;
}
function _temp5($_2) {
  return $_2.action.fail;
}
function _temp6($_3) {
  return $_3.action.stepUp;
}
function _temp7($_4) {
  return $_4.action.identity;
}
function _temp8($_5) {
  return $_5.action.proofOfAddress;
}
function _temp9($_6) {
  return $_6.action.identityProofOfSsn;
}
function _temp10($_7) {
  return $_7.action.identityProofOfSsnProofOfAddress;
}
function _temp11($_8) {
  return $_8.noTriggeredRules;
}
function _temp12($_9) {
  return $_9.noNotTriggeredRules;
}
function _temp13(t0) {
  const {
    ruleId,
    ruleExpression
  } = t0;
  return <RuleRow key={ruleId} ruleExpression={ruleExpression} />;
}
function _temp14($_10) {
  return $_10.onboardingDecision;
}
function _temp15($_11) {
  return $_11.title;
}